import { FC } from 'react';
import { Stack, TextInput, ActionIcon, Group, Paper } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { SignerEntry } from '../types/template.types';

export interface SignatureBlockProps {
  /** Signer data */
  signer: SignerEntry;
  /** Called when signer data changes */
  onChange: (signer: SignerEntry) => void;
  /** Called when remove button is clicked */
  onRemove?: () => void;
  /** Whether the remove button should be shown */
  removable?: boolean;
}

export const SignatureBlock: FC<SignatureBlockProps> = ({
  signer,
  onChange,
  onRemove,
  removable = false,
}) => {
  return (
    <Paper withBorder p="md" radius="md" shadow="sm">
      <Stack gap="xs" flex={1} miw={200}>
        <TextInput
          label="Ονοματεπώνυμο"
          placeholder="Εισάγετε ονοματεπώνυμο"
          value={signer.name}
          onChange={(e) => onChange({ ...signer, name: e.target.value })}
        />
        <Group>
          <TextInput
            label="Τίτλος / Ιδιότητα"
            placeholder="π.χ. Καθηγητής Ιατρικής Γενετικής"
            value={signer.title}
            onChange={(e) => onChange({ ...signer, title: e.target.value })}
            flex={1}
          />

          {removable && (
            <ActionIcon
              variant="subtle"
              color="red"
              size="sm"
              mt="lg"
              onClick={onRemove}
              title="Αφαίρεση υπογράφοντα"
            >
              <IconTrash size={14} />
            </ActionIcon>
          )}
        </Group>
      </Stack>
    </Paper>
  );
};

export default SignatureBlock;
